import React from 'react';

/**
 * GoDaddyLogo - The 2020 GoDaddy heart-shaped "GO" logo.
 * AC-638: Created for GoDaddy tool identification in tool modals.
 * The logo features a heart shape that stylistically spells "GO".
 */
export interface GoDaddyLogoProps {
  className?: string;
}

const GoDaddyLogo: React.FC<GoDaddyLogoProps> = ({ className = "w-4 h-4" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-label="GoDaddy"
  >
    {/* Heart-shaped "GO" logo (2020 rebrand) */}
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
    {/* "GO" letters integrated into heart - flips with theme so it stays legible against the currentColor heart */}
    <text
      x="12"
      y="12"
      fontSize="6"
      fontWeight="bold"
      textAnchor="middle"
      className="fill-white dark:fill-night"
      fontFamily="Arial, sans-serif"
    >
      GO
    </text>
  </svg>
);

export default GoDaddyLogo;
